import { Injectable } from '@angular/core';
import { ApiBaseService } from '@core/services/api-base.service';
import { Mapper } from '@core/services/mapper';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DriversType } from "@shared-features/enums/drivers-type.enum";
import { ApiConstant } from '@shared/constants/api.constant';
import { filterNullEntity } from '@shared/utils/filter-null-entity.util';
import { Driver } from '@features/fleets/models/driver';
import { Elm } from '@features/fleets/models/elm';
@Injectable({
  providedIn: 'root',
})
export class DriversCommonApiService {
  constructor(private baseAPI: ApiBaseService, private mapper: Mapper) {}

  getActiveDrivers(
    driverType?: DriversType,
    fleetId?: number,
    searchTerm?: string,
  ): Observable<Driver[]> {
    const params = filterNullEntity({
    driverType,
    fleetId,
    searchTerm,
    platform: 'WEB',
    });
    return this.baseAPI.get(ApiConstant.GET_ACTIVE_DRIVERS, { params }).pipe(
      map((res) => {
        return this.mapper.fromJson(Driver, res.data);
      })
    );
  }

  getDriverById(driverId: string): Observable<Driver> { // related to drivers
    return this.baseAPI.get(ApiConstant.GET_DRIVER_BY_ID + driverId).pipe(
      map((res) => {
        return this.mapper.fromJson(Driver, res.data);
      })
    );
  }

  driverIntegrateWithElem(
    birthDate:  Date| string,
    iqamaId: number,
    isForVerification: boolean
  ): Observable<Elm> {
    const params = { iqamaId, birthDate, isForVerification };
    return this.baseAPI.get(ApiConstant.INTEGRATE_WITH_3LEM, { params }).pipe(
      map((res) => {
        return this.mapper.fromJson(Elm, res.data);
      })
    );
  }
}
